import { Card, SectionHeader } from "../../components/lib";
import { CHANNELS } from "../../mocks/growthData";

export default function Attribution() {
  const totalSpend = CHANNELS.reduce((s, c) => s + c.spendEGP, 0);
  const totalRev   = CHANNELS.reduce((s, c) => s + c.revenueEGP, 0);
  const maxRev     = Math.max(1, ...CHANNELS.map((c) => c.revenueEGP));

  return (
    <div className="space-y-6" data-testid="gr-attribution">
      <Card testId="gr-a-summary">
        <SectionHeader eyebrow="Attribution" title="Channel revenue vs spend" />
        <div className="grid grid-cols-3 gap-4">
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Total spend (30d)</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>EGP {(totalSpend/1000).toFixed(0)}K</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Total revenue (30d)</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-success)" }}>EGP {(totalRev/1_000_000).toFixed(2)}M</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Blended ROAS</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-success)" }}>{(totalRev/Math.max(1,totalSpend)).toFixed(2)}x</div></div>
        </div>
      </Card>

      <Card padded={false} testId="gr-a-channels">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Channels" title={`${CHANNELS.length} channels`} />
        </div>
        <div className="p-4 space-y-3">
          {CHANNELS.map((c) => {
            const bar = Math.max(3, (c.revenueEGP / maxRev) * 100);
            return (
              <div key={c.key} data-testid={`gr-ch-${c.key}`} className="grid items-center gap-3" style={{ gridTemplateColumns: "1.4fr 4fr 1fr 1fr" }}>
                <div>
                  <div className="text-sm font-semibold" style={{ color: "var(--ph-ink-strong)" }}>{c.name}</div>
                  <div className="text-[10px] tabular-nums" style={{ color: "var(--ph-ink-muted)" }}>{c.ordersLast30} orders · EGP {(c.spendEGP/1000).toFixed(0)}K spent</div>
                </div>
                <div className="h-2 rounded" style={{ background: "var(--ph-border-subtle)", overflow: "hidden" }}>
                  <div style={{ width: `${bar}%`, height: "100%", background: "var(--ph-brand-primary)" }} />
                </div>
                <div className="text-sm tabular-nums text-right" style={{ color: "var(--ph-ink-strong)" }}>EGP {(c.revenueEGP/1000).toFixed(0)}K</div>
                <div className="text-sm tabular-nums text-right" style={{ color: c.ROAS > 4 ? "var(--ph-success)" : c.ROAS > 0 ? "var(--ph-ai)" : "var(--ph-ink-muted)" }}>{c.ROAS > 0 ? `${c.ROAS.toFixed(1)}x` : "organic"}</div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
